export const ORIGIN_PM = 'Pmkino'
export const ORIGIN_DATA_PROVIDER = 'DataProvider'
export const ORIGIN_TMDB = 'Tmdb'